export default __webpack_public_path__ + "static/media/sulger-stiftung.b4a0ed96.webp";